// ignore-string-externalization

import { getAccessToken } from './accessTokenManager';

export async function tokenProvider(): Promise<[string, number]> {
  const [token, expiresIn] = await getAccessToken();
  if (!token) throw new Error('logged out');
  return [token, expiresIn];
}
